import {
  Box,
  Flex,
  Grid,
  Heading,
  Spinner,
  Text,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import CreateExamMenu from "../../../components/student/CreateExamMenu";
import StudentPortalShell from "../../../components/student/StudentPortalShell";
import ExamMainData from "../../../containers/student/exams/exam-main-data";
import { studentPalette } from "../../../constants/studentPalette";
import { studentSurfaces } from "../../../constants/studentThemeSurfaces";
import { getStudentChaptersRequest } from "../../../modules/students-modules/chapters/Actions";
import { getStudentExamsRequest } from "../../../modules/students-modules/student-exams/Actions";
import {
  studentExamGuidePath,
  studentExamResultPath,
} from "../../../utils/studentExamPaths";

const C = {
  primary: studentPalette.primary,
  muted: studentSurfaces.textMuted,
};

const StudentExamsPage = () => {
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get("returnTo") || "";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const studentExams = useSelector((state) => state.studentExams.studentExams);
  const isLoading = useSelector((state) => state.studentExams.isLoading);

  useEffect(() => {
    dispatch(getStudentExamsRequest());
    dispatch(getStudentChaptersRequest());
  }, [dispatch]);

  useEffect(() => {
    if (!returnTo) {
      try {
        sessionStorage.removeItem("edutopia_post_exam_redirect");
      } catch {
        /* ignore */
      }
    }
  }, [returnTo]);

  const handleSolveExam = (data) => {
    navigate(studentExamGuidePath(data?.id, data?.name));
  };

  const handleCheckExamAnswers = (data) => {
    navigate(studentExamResultPath(data?.id, data?.name));
  };

  const examList = Array.isArray(studentExams) ? studentExams : [];

  return (
    <StudentPortalShell>
      <Box p={{ base: 4, md: 8 }} maxW="container.2xl" w="100%" minW={0}>
        <VStack align="stretch" spacing={4} mb={8} w="100%">
          <Box minW={0}>
            <Heading
              as="h1"
              fontSize={{ base: "2xl", md: "3xl" }}
              fontWeight="800"
              color={C.primary}
              fontFamily="'Tajawal','Amiri',sans-serif"
              mb={2}
              sx={{ "html[data-theme='dark'] &": { color: "var(--text-primary)" } }}
            >
              Student Exams
            </Heading>
            <Text fontSize="sm" color={C.muted}>
              Create practice exams and track your progress.
            </Text>
          </Box>
          <Box alignSelf="flex-start" display="flex" justifyContent="flex-start">
            <CreateExamMenu />
          </Box>
        </VStack>

        {isLoading && examList.length === 0 ? (
          <Flex justify="center" py={16}>
            <Spinner size="lg" color={C.primary} />
          </Flex>
        ) : examList.length === 0 ? (
          <Text color={C.muted} fontWeight="600">
            No exams yet. Use Create Exam below to start a practice session.
          </Text>
        ) : (
          <Grid
            templateColumns="repeat(auto-fill, minmax(min(100%, 280px), 1fr))"
            gap={6}
            w="100%"
            minW={0}
          >
            {examList.map((exam) => (
              <ExamMainData
                key={exam.id}
                exam={exam}
                state={exam?.right_answers == null ? "Pending" : "Solved"}
                solveExamFun={handleSolveExam}
                checkExamAnswersFun={handleCheckExamAnswers}
                returnTo={returnTo}
              />
            ))}
          </Grid>
        )}
      </Box>
    </StudentPortalShell>
  );
};

export default StudentExamsPage;
